import PropTypes from 'prop-types';
import { createSelector, createStructuredSelector } from 'reselect';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Context, { withContext } from './QuestionnaireContext';
import SelectorsHub from './SelectorsHub';
import {
  argument,
  property,
  higherOrderSelector,
} from '../../utilsClient/selectors';

class Element extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.getContext = createSelector(
      argument(0, 'context'),
      argument(0, 'id'),
      (context, elementId) => {
        if (context) {
          return context.createSubContext(elementId);
        }
        return null;
      },
    );
    this.handleMoveUp = this.handleMoveUp.bind(this);
    this.handleMoveDown = this.handleMoveDown.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  handleRemove() {
    const { id, dispatch, context, contextOptions } = this.props;
    if (contextOptions && contextOptions.disabled) {
      return;
    }
    dispatch(context.removeElement(id));
  }

  handleMoveUp() {
    const { id, dispatch, context, contextOptions } = this.props;
    if (contextOptions && contextOptions.disabled) {
      return;
    }
    dispatch(context.moveElementUp(id));
  }

  handleMoveDown() {
    const { id, dispatch, context, contextOptions } = this.props;
    if (contextOptions && contextOptions.disabled) {
      return;
    }
    dispatch(context.moveElementDown(id));
  }

  render() {
    const { children, ...props } = this.props;
    if (typeof children === 'function') {
      return (
        <Context.Provider value={this.getContext(props)}>
          {children({
            handleRemove: this.handleRemove,
            handleMoveUp: this.handleMoveUp,
            handleMoveDown: this.handleMoveDown,
          })}
        </Context.Provider>
      );
    }
    return (
      <Context.Provider value={this.getContext(props)}>
        {children}
      </Context.Provider>
    );
  }
}

Element.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  dispatch: PropTypes.func.isRequired,
  context: PropTypes.instanceOf(SelectorsHub).isRequired,
  contextOptions: PropTypes.objectOf(PropTypes.any),
};

Element.defaultProps = {
  children: null,
  contextOptions: null,
};

export default compose(
  withContext(),
  connect(() => {
    return createStructuredSelector({
      contextOptions: higherOrderSelector(property('context'), (context) =>
        context.select.options(),
      ),
    });
  }, null),
)(Element);
